<template>
  <el-dialog
    title="Insert track"
    :visible="dialog_form"
    width="30%"
    top="3vh"
    :modal="true"
    @open="open"
    @close="setTrackDialog(false)"
  >
    <el-form ref="track" :model="track" label-position="top">
      <el-form-item label="Track" prop="artist">
        <el-select v-model="track.id" clearable filterable>
          <el-option
            v-for="t in track_list"
            :key="t.id"
            :value="t.id"
            :label="`${t.artist[0].name} - ${t.title}`"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Daterange" prop="daterange">
        <el-date-picker
          v-model="track.date_range"
          type="daterange"
          unlink-panels
          range-separator="-"
          start-placeholder="Start date"
          end-placeholder="End date"
          :picker-options="dateRangeOptions"
          format="d MMMM yyyy"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="primary" size="mini" @click="createTrack()">
        Save
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState('labelTrackVidCents', ['track', 'track_list', 'dialog_form'])
  },

  methods: {
    ...mapActions('labelTrackVidCents', ['createTrack', 'readTrackList']),
    ...mapMutations('labelTrackVidCents', ['setTrackDialog', 'setTrack']),

    open() {
      this.readTrackList()
    }
  }
}
</script>
